import { render, staticRenderFns } from "./attachmentUpload.vue?vue&type=template&id=b926f414&scoped=true"
import script from "./attachmentUpload.vue?vue&type=script&lang=js"
export * from "./attachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./attachmentUpload.vue?vue&type=style&index=0&id=b926f414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b926f414",
  null
  
)

export default component.exports